import React, { useState } from 'react';
import { HeaderBar, Wrapper, CtaButton, Footer, CARD } from './Shared';
import { track, sendLead, saveLead, getLead, firstName } from './pixel';
import { PRIVACY_URL, TERMS_URL, BRAND } from './config';

// PASO 2: preguntas de filtro, una por pantalla (estilo aplicación). Ya dio sus datos -> alta tasa de finalización.
type Q = {
  key: string;
  q: string;
  options?: string[];
  stopIf?: string;
};
const QUESTIONS: Q[] = [{
  key: 'work_auth',
  q: '¿Tienes autorización para trabajar en Estados Unidos?',
  options: ['Sí', 'No'],
  stopIf: 'No'
},
// Nadie queda fuera por no tener licencia: la mayoría son reclutas nuevos y Chale los guía para sacarla
{
  key: 'license',
  q: '¿Ya tienes licencia de seguros de vida? Si no la tienes, no te preocupes: te guiamos para sacarla.',
  options: ['Ya tengo licencia', 'Todavía no, pero quiero sacarla', 'Todavía no, quiero saber cómo funciona']
}, {
  key: 'hours',
  q: '¿Cuántas horas por semana podrías dedicarle?',
  options: ['Menos de 5', '5 a 10', '10 a 20', 'Más de 20']
},
// La pregunta de costos se eliminó a pedido: los costos se explican en el video y en la llamada.
{
  key: 'why',
  q: 'Última: ¿por qué quieres construir algo propio? Cuéntame en 2 o 3 líneas.'
}];

// Cuántas preguntas tienen respuesta (sirve para "preguntas_respondidas" en GHL)
function answeredCount(a: Record<string, string>) {
  return QUESTIONS.filter(x => String(a[x.key] || '').trim()).length;
}

// Texto exacto del consentimiento: se guarda en GHL junto con la fecha (prueba de consentimiento TCPA / A2P 10DLC)
const CONSENT_TEXT = `Acepto recibir llamadas, mensajes de texto (SMS), WhatsApp y correos de ${BRAND} y su equipo sobre esta solicitud al número que proporcioné, incluso enviados con sistemas automatizados. El consentimiento no es condición de compra. La frecuencia de mensajes varía. Pueden aplicar tarifas de mensajes y datos. Responde STOP para cancelar o HELP para ayuda.`;
export function Qualify({
  onDone
}: {
  onDone: () => void;
}) {
  const [i, setI] = useState(0);
  const [answers, setAnswers] = useState<Record<string, string>>({});
  const [why, setWhy] = useState('');
  const [consent, setConsent] = useState(false);
  const [err, setErr] = useState('');
  const [stopped, setStopped] = useState(false);
  const name = firstName();
  const q = QUESTIONS[i];
  const pct = Math.round((i + 1) / QUESTIONS.length * 100);

  // GUARDADO PROGRESIVO: cada respuesta actualiza el MISMO contacto en GHL (mismo email/teléfono),
  // así lo respondido queda registrado aunque la persona abandone a mitad del paso 2.
  const sendProgress = (a: Record<string, string>, lastKey: string) => {
    sendLead({
      step: 'progreso',
      ...getLead(),
      ...a,
      aplicacion_estado: 'incompleta',
      ultima_pregunta: lastKey,
      preguntas_respondidas: `${answeredCount(a)} de ${QUESTIONS.length}`
    });
  };
  const pick = async (opt: string) => {
    const next = {
      ...answers,
      [q.key]: opt
    };
    setAnswers(next);
    saveLead(next);
    if (q.stopIf && opt === q.stopIf) {
      setStopped(true);
      await sendLead({
        step: 'no_califica',
        ...getLead(),
        ...next,
        aplicacion_estado: 'no_califica',
        ultima_pregunta: q.key,
        preguntas_respondidas: `${answeredCount(next)} de ${QUESTIONS.length}`
      });
      return;
    }
    sendProgress(next, q.key);
    setI(i + 1);
  };

  // La respuesta abierta también se guarda al salir del campo (si escribió algo)
  const saveWhyDraft = () => {
    const text = why.trim();
    if (!text || text === String(getLead().why || '')) return;
    const next = {
      ...answers,
      why: text
    };
    saveLead({
      why: text
    });
    sendProgress(next, 'why');
  };
  const finish = async (e: React.FormEvent) => {
    e.preventDefault();
    if (why.trim().length < 20) return setErr('Cuéntame un poquito más (mínimo 20 caracteres).');
    if (!consent) return setErr('Necesito tu autorización para contactarte por WhatsApp.');
    const all = {
      ...answers,
      why: why.trim(),
      consent: true,
      consent_text: CONSENT_TEXT,
      consent_at: new Date().toISOString(),
      consent_page: window.location.href
    };
    saveLead(all);
    await sendLead({
      step: 'aplicacion',
      ...getLead(),
      ...all,
      aplicacion_estado: 'completa',
      ultima_pregunta: 'why',
      preguntas_respondidas: `${QUESTIONS.length} de ${QUESTIONS.length}`
    });
    track('SubmitApplication');
    onDone();
  };
  return <div className="funnel-root bg-white min-h-screen flex flex-col" data-id="element-644" data-mp="13gxer1t0qgb7">
      <HeaderBar data-id="element-645" data-mp="18a8r1iglnpai" />
      <section className="flex-1 pt-10 sm:pt-16 pb-20 sm:pb-24" data-id="element-646" data-mp="18arxo30sur98">
        <Wrapper className="max-w-[760px] text-center" data-id="element-647" data-mp="uibzpgmr9jf6">
          {!stopped && <>
              <p className="font-semibold text-brand text-[14px] sm:text-[15px]" data-id="element-648" data-mp="zg3tkg6ynfm0">Paso 2 de 2 · Ya casi terminas</p>
              <div className="mt-3 h-2 rounded-full bg-brand-light overflow-hidden" data-id="element-649" data-mp="kknvm039ezkc">
                <div className="h-full rounded-full bg-brand transition-[width] duration-300 ease-out" style={{
              width: `${pct}%`
            }} data-id="element-650" data-mp="piz4a7htj40z" />
              </div>
              <p className="mt-6 font-bold text-[18px] sm:text-[22px] text-ink [text-wrap:balance]" data-id="element-651" data-mp="5z0b2dt59t0y">{name ? `${name}, ` : ''}respondes {QUESTIONS.length} preguntas rápidas y apartas tu horario.</p>
            </>}

          {stopped ? <div className={`${CARD} mt-4 p-6 sm:p-10 step-in`} data-id="element-652" data-mp="avqy5l3d9ovv">
              <h2 className="font-extrabold tracking-tight text-[24px] sm:text-[32px] leading-tight text-ink" data-id="element-653" data-mp="ovs1d773t8ei">Gracias por tu sinceridad{name ? `, ${name}` : ''}.</h2>
              <p className="mt-4 text-[16px] sm:text-[20px] text-gray-700 leading-snug" data-id="element-654" data-mp="kty2n4ggyegz">Por ahora este programa requiere autorización para trabajar en EE.UU. Si tu situación cambia, aquí estaré.</p>
            </div> : <div key={i} className={`${CARD} mt-6 p-6 sm:p-10 text-left step-in`} data-id="element-655" data-mp="18jsf3kwvm10p">
              <p className="text-[13px] font-semibold text-brand" data-id="element-656" data-mp="18hoepcy6rk56">Pregunta {i + 1} de {QUESTIONS.length}</p>
              <h2 className="mt-2 font-extrabold tracking-tight text-[22px] sm:text-[30px] leading-tight text-ink" data-id="element-657" data-mp="13iuyhcrilf1b">{q.q}</h2>

              {q.options ? <div className="mt-6 grid gap-3" data-id="element-658" data-mp="1fnqvfr53ur2i">
                  {q.options.map(o => <button key={o} type="button" onClick={() => pick(o)} className={`w-full rounded-xl border-2 px-5 py-4 sm:py-5 text-left text-[17px] sm:text-[19px] font-semibold transition-colors duration-150 ease-out ${answers[q.key] === o ? 'border-brand bg-brand text-white' : 'border-gray-200 bg-white text-ink hover:border-brand'}`} data-id="element-659" data-mp="1kla6yjaf4pqr">
                      {o}
                    </button>)}
                </div> : <form id="qualForm" onSubmit={finish} className="mt-6 space-y-5" data-id="element-660" data-mp="28bwem9gig808">
                  <textarea value={why} onChange={e => {
              setWhy(e.target.value);
              if (err) setErr('');
            }} onBlur={saveWhyDraft} placeholder="Quiero construir algo propio porque…" aria-label="¿Por qué quieres construir algo propio?" className="w-full min-h-[140px] rounded-xl border border-gray-200 bg-white px-5 py-4 text-[16px] sm:text-[18px] text-ink outline-none transition-[border-color,box-shadow] duration-150 ease-out focus:border-brand focus:ring-4 focus:ring-brand-light placeholder:text-gray-400" data-id="element-661" data-mp="8ysbw7gpvktr" />
                  <p className={`-mt-3 text-[13px] ${why.trim().length >= 20 ? 'text-brand font-semibold' : 'text-gray-500'}`} data-id="element-662" data-mp="3nw5gnmo548t3">
                    {why.trim().length >= 20 ? 'Perfecto, gracias.' : `Mínimo 20 caracteres · llevas ${why.trim().length}`}
                  </p>
                  {/* Casilla NO marcada por defecto: el consentimiento debe ser una acción expresa */}
                  <label className="flex items-start gap-3 text-[13px] sm:text-[14px] leading-relaxed text-gray-600" data-id="element-663" data-mp="aeo1flnophhe">
                    <input type="checkbox" checked={consent} onChange={e => {
                setConsent(e.target.checked);
                if (err) setErr('');
              }} className="mt-0.5 h-5 w-5 shrink-0" data-id="element-664" data-mp="306kukuwowvfl" />
                    <span data-id="element-665" data-mp="3ktsqrci31bqa">
                      {CONSENT_TEXT} Consulta la <a href={PRIVACY_URL} className="underline" data-id="element-666" data-mp="3kwez3ecsrv9k">Política de Privacidad</a> y los <a href={TERMS_URL} className="underline" data-id="element-667" data-mp="3pugik0e4xwlk">Términos</a>.
                    </span>
                  </label>
                  {err && <p role="alert" className="text-sm font-medium text-red-600" data-id="element-668" data-mp="3fuzbpfn5dco0">{err}</p>}
                  {/* El botón nombra la recompensa (su lugar con Chale), no la tarea. El sub avisa del video para que no haya sorpresa. */}
                  <CtaButton type="submit" form="qualForm" label="Apartar mi horario con Chale" sub="Último paso · antes, un video corto de Chale" data-id="element-669" data-mp="cd7glsdpscll" />
                </form>}

              {i > 0 && <button type="button" onClick={() => setI(i - 1)} className="mt-5 text-[14px] font-medium text-gray-500 underline underline-offset-4" data-id="element-670" data-mp="2no02tdh4utw">← Volver</button>}
            </div>}
        </Wrapper>
      </section>
      <Footer data-id="element-671" data-mp="v6bbfh2o4vhs" />
    </div>;
}